import axios from 'axios';

const SetupBackEnd = axios.create({
    baseURL: 'http://127.0.0.1:8080'          // LOCAL
    // baseURL: 'http://52.224.194.71'          // HOMOLOG
});

export default SetupBackEnd;
